export interface ProjectSummaryResult {
  projectId: number;
  projectName: string;
}

export interface JobTypePerformanceStats {
  avgCpuPercent: number | null;
  avgRamMb: number | null;
  avgRuntimeSeconds: number;
  jobCount: number;
  jobType: string;
  maxCpuPercent: number | null;
  maxFinished: string | null;
  maxRamMb: number | null;
  maxRuntimeMinutes: number;
  minStarted: string | null;
}

export interface ProjectRunPerformanceResult {
  datePublished: string | null;
  jobTypeBreakdown: JobTypePerformanceStats[];
  projectRunConfigurationId: number;
  totalWallClockMinutes: number | null;
}

export type MetricKey = 'MaxRuntimeMinutes' | 'AvgRuntimeSeconds' | 'MaxCpuPercent' | 'AvgCpuPercent' | 'MaxRamMb' | 'AvgRamMb';

export interface MetricOption {
  key: MetricKey;
  label: string;
  unit: string;
}

export const METRIC_OPTIONS: MetricOption[] = [
  { key: 'MaxRuntimeMinutes', label: 'Max Runtime', unit: 'min' },
  { key: 'AvgRuntimeSeconds', label: 'Avg Runtime', unit: 'sec' },
  { key: 'MaxCpuPercent', label: 'Max CPU', unit: '%' },
  { key: 'AvgCpuPercent', label: 'Avg CPU', unit: '%' },
  { key: 'MaxRamMb', label: 'Max RAM', unit: 'MB' },
  { key: 'AvgRamMb', label: 'Avg RAM', unit: 'MB' },
];
